import Header from "@commons/header";
import Column from "@components/column";
import Tab from "@components/tabs";
import React from "react";
import General from "./general";
import Order from "./order";
import Payment from "./payment";
import Customer from "./customer";
import Cancellation from "./cancellation";
import ModuleWiseColor from "./color";
import Onboarding from "./onboarding";
import EmailTemplates from "./email-templates";
import SplashScreen from "./splash-screen";

const BusinessSettings = () => {
  const items: any = [
    { label: "General", component: General },
    { label: "Payment", component: Payment },
    { label: "Order", component: Order },
    { label: "Cancellation", component: Cancellation },
    { label: "Customers", component: Customer },
    { label: "Onboarding Screen", component: Onboarding },
    { label: "Splash Screen Loading", component: SplashScreen },
    { label: "Email Templates", component: EmailTemplates },
  ];
  return (
    <Column>
      <Header title="Business Setup" />
      <Tab items={items} />
    </Column>
  );
};

export default BusinessSettings;
